import { Card as ChakraCard } from '@chakra-ui/react';
import type { ComponentProps } from 'react';

type CardProps = ComponentProps<typeof ChakraCard.Root> & {
  children: React.ReactNode;
};

export const Card = ({ children, ...props }: CardProps) => {
  return (
    <ChakraCard.Root width="full" bg="transparent" {...props}>
      <ChakraCard.Body>{children}</ChakraCard.Body>
    </ChakraCard.Root>
  );
};
